export default {
  // components
  Email: 'Email',
  'For example abc@example.com': 'For example abc@example.com',
  'Phone number': 'Phone Number',
  'For example <bdi>+971 55 123 4567</bdi>': 'For example <bdi>+971 55 123 4567</bdi>',
  '{{label}} (optional)': '{{label}} (optional)',
  'Contact us': 'Contact us',
  Dashboard: 'Dashboard',
  'Please, fix application data': 'Please, fix application data',
  Continue: 'Continue',
  Total: 'Total',
  'VAT 5%': 'VAT 5%',
  'Pricing has changed': 'Pricing has changed',
  'Save changes to see total price': 'Save changes to see total price',
  Logout: 'Logout',
  Services: 'Services',
  Application: 'Application',
  Agreement: 'Agreement',
  Contract: 'Contract',
  Payment: 'Payment',
  Completion: 'Completion',
  'Drag & Drop Your files here or <strong>Browse</strong>': 'Drag & Drop your Files here or <strong>Browse</strong>',
  'Files supported: JPG, JPEG, DOC, DOCX, PNG, PDF, RTF, GIF. Max size {{size}}':
    'Files supported: JPG, JPEG, DOC, DOCX, PNG, PDF, RTF, GIF. Max size {{size}}',
  'I agree to the above Fees and Charges': 'I agree to the above Fees and Charges',
  Optional: 'Optional',
  Yes: 'Yes',
  No: 'No',
  Ok: 'ok',
  'Discard changes?': 'Discard changes?',
  Close: 'Close',
  Save: 'Save',
  Upload: 'Upload',
  Language: 'Language',
  Cancel: 'Cancel',
  Submit: 'Submit',
  Copied: 'Copied',
  // Days of week
  MO: 'Monday',
  TU: 'Tuesday',
  WE: 'Wednesday',
  TH: 'Thursday',
  FR: 'Friday',
  SA: 'Saturday',
  SU: 'Sunday',
  // Company type page
  'Get started': 'Get started',
  'with Network International': 'with Network International',
  'Now we know about you, please tell us a little about your business.':
    'Now we know about you, please tell us a little about your business.',
  'I agree to the <1>Terms and Conditions</1> and <3>Privacy Policy</3>':
    'I agree to the <1>Terms and Conditions</1> and <3>Privacy Policy</3>',
  'Company type': 'Company type',
  'Business nature': 'Business Nature',
  'Business line': 'Business Line',
  Confirm: 'Confirm',
  'Please confirm that your company is not an Aggregator or Marketplace':
    'Please confirm that your company is not an Aggregator or Marketplace',
  'Agree and Continue': 'Agree and Continue',
  'Reselect Company Type': 'Reselect Company Type',
  '<strong>Small and Medium Enterprise</strong> – you operate your own business selling your own goods or services.':
    '<strong>Small and Medium Enterprise</strong> – you operate your own business selling your own goods or services.',
  'Please select the nature of your business from the list which most closely defines your primary trading purpose.':
    'Please select the nature of your business from the list which most closely defines your primary trading purpose.',
  'Please select the business line which most closely fits your primary trading purpose.':
    'Please select the business line which most closely fits your primary trading purpose.',
  // Get in touch page
  'Get in touch': 'Get in touch',
  'Thank you for the information provided so far.': 'Thank you for the information provided so far.',
  'Due to your business type, we will need one of our dedicated team to take you through the application process to ensure the right services for you.':
    'Due to your business type, we will need one of our dedicated team to take you through the application process to ensure the right services for you.',
  'Please contact us via our <1>Contact us page</1> to arrange a call back.':
    'Please contact us via our <1>Contact us page</1> to arrange a call back.',
  // Lets start
  'Excellent!': 'Excellent!',
  'Now we know a little bit more about you and your business, we can now move onto the full application process.':
    'Now we know a little bit more about you and your business, we can now move onto the full application process.',
  'This process should take no more than 30 minutes.': 'This process should take no more than 30 minutes.',
  'You can also leave at any point and return by using the same email address you provided to us at the start.':
    'You can also leave at any point and return by using the same email address you provided to us at the start.',
  'Let’s start!': 'Let’s start!',
  'For successful submission you will need the following documents:':
    'For successful submission you will need the following documents:',
  'Copy of Company’s Trade License along with relevant pages evidencing shareholding percentage.':
    'Copy of Company’s Trade License along with relevant pages evidencing shareholding percentage.',
  'Copy of Emirates ID and Visa (if applicable) of the Ultimate Beneficial Owner*/Controlling shareholder/authorised signatory.':
    'Copy of Emirates ID and Visa (if applicable) of the Ultimate Beneficial Owner*/Controlling shareholder/authorised signatory.',
  'Copy of Memorandum of Association/Article of Association/Board resolution and Power of Attorney (POA) if applicable for Sole Proprietorship.':
    'Copy of Memorandum of Association/Article of Association/Board resolution and Power of Attorney (POA) if applicable for Sole Proprietorship.',
  'Passport copy of Ultimate Beneficial Owner*/Controlling shareholder/authorised signatory.':
    'Passport copy of Ultimate Beneficial Owner*/Controlling shareholder/authorised signatory.',
  'IBAN Proof/Copy of Bank Statement evidencing IBAN number.':
    'IBAN Proof/Copy of Bank Statement evidencing IBAN number.',
  'Copy of Tax Registration certificate (if applicable).': 'Copy of Tax Registration certificate (if applicable).',
  'Copy of the Tenancy Contract Information registration Certificate (Ejari).':
    'Copy of the Tenancy Contract Information registration Certificate (Ejari).',
  'Letter of Intent (in case exact activities not mentioned in the Trade License).':
    'Letter of Intent (in case exact activities not mentioned in the Trade License).',
  '* Shareholder/Ultimate beneficial owner with shareholding percentage of 25% or more':
    '* Shareholder/Ultimate beneficial owner with shareholding percentage of 25% or more',
  'Download File': 'Download File',
  ACCOUNT_MAINTAENANCE: 'Account Maintenance',
  CONFIGURATION: 'Configuration',
  sourceChannel: 'Source Channel',
  'businessCard.pctList': 'PCT',
  'corporateExecutive.pctList': 'PCT',
  'digitalBusinesspayments.pctList': 'PCT',
  'digitalBusinessTravel.pctList': 'PCT',
  CARD_ISSUANCE: 'Card Rebate AccuralIssuance',
  CHASHBACK_REDEMPTION_REBATE: 'Rebate Accural',
  HIERARCHY_LEVELS: 'Hierarchy Levels',
  PRODUCT_PERCENTAGE_BALANCE: 'Percentage of settlement account balance to be used for product account Top up',
  TRANSACTION_FEES: 'Transaction Fees',
  PPRTALS_STATEMENTS_NOTIFICATIONS: 'Portals, Statements & Notifications',
  'Personal Details': 'Personal Details',
  Consent: 'Consent',
  DIGITAL_BUSINESS_PAYMENT: 'Digital Business Payments',
  CardOrderDetails: 'Card Order Details',
  CORPORATE_EXECUTIVE_CARD: 'Corporate Executive',
  BUSINESS_CARD: 'Max Business Card',

  DIGITAL_TRAVEL_PAYMENT: 'Digital Travel Payment',
  name: 'Name',
  sureName: 'Sure Name',
  email: 'Email',
  phoneNumber: 'Phone Number',
  position: 'Position',
  procurementRelated: 'Procurement related',
  vehicleExpenseRelated: 'Vehicle expense related',
  travelRelated: 'Travel related',
  firstName: 'First name',
  passport: 'Passport',
  companyLicense: 'Company License',
  companyEmbossing: 'Company Name',
  companyEmbossingHelperText: 'Maximum 21 characters allowed',

  'services.servicesDetails': 'Product Solutions',
  'services.selectServices': 'Product Selection',
  'services.cardOrderDetails': 'Hierarchy and Card Details',
  'services.adminstrator': 'Portal User',
  'delete.confirmation.modal.title': 'Are you sure you want to delete the user?',
  'delete.confirmation.modal.description':
    'Deleting the user will remove all the data and the user from the current user list.',
  'delete.confirmation.modal.okText': 'Yes',
  'delete.confirmation.modal.cancelText': 'No',
  'Update made to our services': 'Update made to our services',
  'Updates to our services have been made. Kindly revisit the selected services and verify your application details.':
    'Updates to our services have been made. Kindly revisit the selected services and verify your application details.',
  'submit.confirmation.modal.title': 'Are you sure you want to submit the form? ',
  'submit.confirmation.modal.description': 'Please note once submitted cannot be edited.',
  'submit.confirmation.modal.okText': 'Yes',
  'submit.confirmation.modal.cancelText': 'No',
};
